module.exports = __webpack_public_path__ + "static/media/grafana_good_data.40c3094f.png";